import React from "react";

import { toast } from "react-toastify";
import Layout from "../../components/Layout/Layout";
import Loading from "../../components/Loading";
import CustomModal, { ModalInput, ModalSelect } from "../../components/Modal";
import Search from "../../components/Search";
import CustomSelect from "../../components/Select";
import Success from "../../components/Success";
import EditStaff from "../../components/staff/EditStaff";
import {
  createIncentiveCredit,
  createPaymentadmin,
  createStaff,
  createStaffSalary,
  getAllStaff,
} from "../../utils/api";
import useStore from "../../utils/store";
const Staff = () => {
  const [open, setOpen] = React.useState(false);
  const startDate = useStore((state) => state.startDate);
  const endDate = useStore((state) => state.endDate);
  const user = useStore((state) => state.user);
  const [staff, setStaff] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [newStaff, setNewStaff] = React.useState(null);
  const [selected, setSelected] = React.useState(null);
  const initialPayment = {
    staffId: "",
    description: "",
    amount: "",
    paymentType: "",
    date: new Date(),
    completedById: user?.admin?._id,
  };
  const [newPayment, setNewPayment] = React.useState(initialPayment);
  const getStaff = async () => {
    setLoading(true);
    const [success, data] = await getAllStaff(startDate, endDate);
    if (success) {
      setStaff(data);
    }
    setLoading(false);
  };

  const addPaymentHandler = async () => {
    if (
      newPayment.staffId === "" ||
      newPayment.amount === "" ||
      newPayment.paymentType === ""
    ) {
      toast.error("Please fill all the fields");
      return;
    }
    setLoading(true);
    let success, data;

    if (newPayment.paymentType === "Salary") {
      [success, data] = await createStaffSalary(newPayment);
    } else if (newPayment.paymentType === "Incentive") {
      [success, data] = await createIncentiveCredit(newPayment);
    } else {
      [success, data] = await createPaymentadmin(newPayment);
    }

    if (success) {
      setNewPayment(initialPayment);
      toast.success("Payment added successfully");
    } else {
      toast.error(data);
    }
    setLoading(false);
  };

  const createNewStaff = async () => {
    if (!newStaff.userName || !newStaff.password || !newStaff.role) {
      alert("Please fill all the fields");
      return;
    }
    setLoading(true);
    const [success, data] = await createStaff(newStaff);
    if (success) {
      setOpen(false);
      setNewStaff({});
      setSuccess(true);
      getStaff();
    }
    setLoading(false);
  };

  React.useEffect(() => {
    getStaff();
  }, [startDate, endDate]);

  return (
    <Layout
      text="Add New Staff"
      onClick={() => {
        setOpen(true);
      }}
    >
      {loading && <Loading />}
      <div className="flex gap-3 flex-col md:flex-row">
        <Search
          data={staff.map((item) => ({
            ...item,
            name: `${item.userName}`,
          }))}
          item={(item) => {
            setSelected(item);
          }}
          active={selected?._id}
        />
        {selected ? (
          <EditStaff item={selected} reload={getStaff} setItem={setSelected} />
        ) : (
          <div>
            <div className="flex md:items-center justify-center gap-3 md:flex-row flex-col ">
              <div className="flex flex-col gap-2">
                <div className="bg-secondary border-2 border-black px-2 py-1">
                  Staff
                </div>
                <CustomSelect
                  onChange={(e) => {
                    setNewPayment({
                      ...newPayment,
                      staffId: e.target.value,
                    });
                  }}
                  options={staff.map((customer) => ({
                    value: customer._id,
                    label: `${customer.userName} `,
                  }))}
                  value={newPayment.staffId}
                />
              </div>
              <div className="flex flex-col gap-2">
                <div className="bg-secondary border-2 border-black px-2 py-1">
                  description
                </div>
                <ModalInput
                  width={"w-full"}
                  value={newPayment?.description}
                  onChange={(e) => {
                    setNewPayment({
                      ...newPayment,
                      description: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="flex flex-col gap-2">
                <div className="bg-secondary border-2 border-black px-2 py-1">
                  Payment
                </div>
                <CustomSelect
                  onChange={(e) => {
                    setNewPayment({
                      ...newPayment,
                      paymentType: e.target.value,
                    });
                  }}
                  options={[
                    { value: "Received", label: "Payment" },
                    { value: "Payment", label: "Received" },
                    { value: "Salary", label: "Salary" },
                    { value: "Incentive", label: "Incentive" },
                  ]}
                  value={newPayment.paymentType}
                />
              </div>
              <div className="flex flex-col gap-2">
                <div className="bg-secondary border-2 border-black px-2 py-1">
                  Amount
                </div>
                <ModalInput
                  width={"w-full"}
                  value={newPayment?.amount}
                  onChange={(e) => {
                    setNewPayment({ ...newPayment, amount: e.target.value });
                  }}
                  type={"number"}
                />
              </div>
              <div className="flex flex-col gap-2">
                <div className="bg-secondary border-2 border-black px-2 py-1">
                  Date
                </div>
                <ModalInput
                  width={"w-full"}
                  value={newPayment?.date}
                  onChange={(e) => {
                    setNewPayment({ ...newPayment, date: e.target.value });
                  }}
                  type={"date"}
                />
              </div>

              <button
                onClick={addPaymentHandler}
                className="border-2 w-full md:w-auto border-black bg-primary text-white py-1 px-2 focus:outline-none"
              >
                Save
              </button>
            </div>
          </div>
        )}
      </div>
      <CustomModal
        open={open}
        setOpen={setOpen}
        onClick={createNewStaff}
        loading={loading}
      >
        <ModalInput
          title="USERNAME"
          onChange={(e) => {
            setNewStaff((prev) => ({ ...prev, userName: e.target.value }));
          }}
        />

        <ModalInput
          title="PASSWORD"
          onChange={(e) => {
            setNewStaff((prev) => ({ ...prev, password: e.target.value }));
          }}
        />
        <ModalSelect
          onChange={(e) => {
            setNewStaff((prev) => ({ ...prev, role: e.target.value }));
          }}
          title="Group"
          options={[
            "TradingStaff",
            "MarketingStaff",
            "StancilStaff",
            "OtherStaff",
            "TagStaff",
            "Dispatch",
            "ViewAdmin",
          ]}
        />
      </CustomModal>
      <Success open={success} setOpen={setSuccess} />
    </Layout>
  );
};

export default Staff;
